import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { FilterTemplateToken } from '@sleed/bizcommerce-api';
import { filterTemplatesApi } from '~/lib/api/client';
import { formToToken, type FilterTemplateFormValues } from '~/lib/schemas/filter-template';

export const filterTemplateKeys = {
	all: ['filter-templates'] as const,
	list: () => [...filterTemplateKeys.all, 'list'] as const
};

export function useFilterTemplatesList() {
	return useQuery<FilterTemplateToken[]>({
		queryKey: filterTemplateKeys.list(),
		queryFn: async () => (await filterTemplatesApi.getAll()).data.items ?? []
	});
}

export function useFilterTemplateMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: filterTemplateKeys.list() });
	const create = useMutation({
		mutationFn: async (form: FilterTemplateFormValues) => (await filterTemplatesApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: FilterTemplateFormValues) => (await filterTemplatesApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({
		mutationFn: async (id: number) => (await filterTemplatesApi.remove(id)).data,
		onSuccess: invalidate
	});
	const copy = useMutation({
		mutationFn: async ({ id, nm }: { id: number; nm: string }) => (await filterTemplatesApi.copy({ nm }, id)).data,
		onSuccess: invalidate
	});
	return { create, update, remove, copy };
}
